import store from "@/store/index";

const checkPermissions = (item) => {
	let currentUser = JSON.parse(sessionStorage.getItem("userData") || localStorage.getItem("userData") || "null");
	if (!currentUser) return false;

	// Company-level module gating — applies to EVERYONE, including owner,
	// since this is "does the company have this feature at all", not a
	// per-role permission. Checked before the owner/super_admin bypass below
	// on purpose. Reads Vuex (not sessionStorage) specifically so nav items
	// re-render automatically when the polling refresh in LayoutVertical.vue
	// commits a new value — Vue's reactivity tracks this store read even
	// though it happens inside a plain function, as long as that function is
	// called synchronously from a component's render (which `v-if="checkPermissions(item)"`
	// is). sessionStorage isn't reactive, so using it here would need a
	// manual re-render trigger on every poll instead of this being automatic.
	// null/missing (not yet fetched, or fetch failed) means "show everything"
	// — fail open, never hide a feature the company actually has just
	// because of a network hiccup.
	const enabledModules = store.state.features?.enabledModules;
	if (item.moduleSlug && Array.isArray(enabledModules)) {
		if (!enabledModules.includes(item.moduleSlug)) {
			return false;
		}
	}

	// role (singular string) — set explicitly on login. This is a
	// human-readable label ("Super Admin"), NOT the machine slug used by
	// item.roles (e.g. "super_admin") — normalize it the same way, so a
	// bare-string role still matches.
	const roleStr = (currentUser.role || "").toLowerCase().replace(/\s+/g, "_");

	// roles (array) — normalize to array of slugs. r.slug is the machine
	// identifier ("super_admin"); r.name is the display label ("Super
	// Admin") and was being compared directly against item.roles slugs
	// here, so it never matched and every role-gated nav item (Company,
	// Roles, Permission, Vet Approvals...) silently hid itself even for a
	// real super_admin.
	const rolesArr = Array.isArray(currentUser.roles)
		? currentUser.roles.map((r) => (typeof r === "object" ? (r.slug || r.name) : r))
		: [];

	// super_admin and owner see everything
	if (roleStr === "super_admin" || roleStr === "owner") return true;
	if (rolesArr.includes("super_admin") || rolesArr.includes("owner")) return true;

	if (item.roles || item.permissions) {
		if (item.roles && (item.roles.includes(roleStr) || rolesArr.some((r) => item.roles.includes(r)))) {
			return true;
		}
		const permissions = Array.isArray(currentUser.permissions) ? currentUser.permissions : [];
		if (item.permissions && permissions.some((p) => item.permissions.includes(p))) {
			return true;
		}
		return false;
	}
	return true;
};
const containsAny = (array1, array2) => {
	return array1.some((e) => array2.indexOf(e) >= 0);
};

export default checkPermissions;
